import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Container, Dimmer, Grid, Header, Icon, Loader, Segment,Form,Button} from 'semantic-ui-react'
import {newClock,getEmployees,get as loadClock,} from '../../reducer/actions';
import {getLoadedClock, isLoading} from '../../reducer';
import WarehouseSelect from '../../components/WarehouseSelect';
import ActivitySelect from '../../components/ActivitySelect';
import EmployeeSelect from '../../components/EmployeeSelect';
import { Translate } from 'react-localize-redux';
import { push } from "react-router-redux";
import moment from 'moment';

// Components
import 'react-dates/lib/css/_datepicker.css';

// Css


class ClockNew extends Component {

    constructor(props) {
        super(props);

        this.state = {
            warehouse_id: null,
            activity_id: null,
            employee_id: null,
            start: moment().format('YYYY-MM-DDTHH:mm:ss'),
            end: moment().format('YYYY-MM-DDTHH:mm:ss'),
        }

    }

    componentWillMount(){
        this.props.init();
    }

    saveClock(deleteClock = false){

        // Validation

        if(this.state.warehouse_id === null || this.state.activity_id === null || this.state.employee_id === null){
            return false;
        }

        if(this.state.start === '' || this.state.end === ''){
            return false;
        }

        this.props.new(this.state).then(({clock})=>{
            this.props.goTo(clock.id);
        });

    }


    render() {
        return (
            <Container style={{padding: '3em 1em'}}>
                <Dimmer active={this.props.isLoading}>
                    <Loader/>
                </Dimmer>
                <Header as='h2' icon textAlign='center'>
                    <Icon name='clock' circular/>
                </Header>
                <Grid
                    textAlign='center'
                    style={{height: '100%'}}
                    verticalAlign='middle'
                >
                    <Grid.Column width={16}>
                        <div>
                            <Header as='h2' color='teal' textAlign='center'>
                                <Translate id="edit" />
                            </Header>
                            <Segment stacked>




                                <Form size='large' loading={this.props.isLoading} onSubmit={()=>{this.saveClock()}}>
                                    <Segment stacked>
                                        <Form.Field required>
                                            <label>Start</label>
                                            <input type="datetime-local"  value={this.state.start}
                                                   step="1"
                                                   onChange={(e)=>{this.setState({start: e.target.value})}}
                                            />
                                        </Form.Field>
                                        <Form.Field required>
                                            <label>End</label>
                                            <input type="datetime-local"  value={this.state.end}
                                                   step="1"
                                                   onChange={(e)=>{this.setState({end: e.target.value})}}
                                            />
                                        </Form.Field>
                                        <ActivitySelect
                                            value={this.state.activity_id}
                                            onChange={(value) => this.setState({activity_id: value})}
                                        />
                                        <WarehouseSelect
                                            value={this.state.warehouse_id}
                                            onChange={(value) => this.setState({warehouse_id: value})}
                                        />
                                        <EmployeeSelect
                                            value={this.state.employee_id}
                                            onChange={(value) => this.setState({employee_id: value})}
                                        />

                                        <Button positive type='submit'>Save</Button>
                                        <Button negative type='button' onClick={()=>{
                                            this.props.back();
                                        }}>Abbruch</Button>
                                    </Segment>
                                </Form>

                            </Segment>
                        </div>
                    </Grid.Column>
                </Grid>
            </Container>
        );
    }

}


const mapStateToProps = state => ({
    isLoading: isLoading(state),
    clock: getLoadedClock(state),

});


function mergeProps(stateProps, dispatchProps, ownProps) {

    return {
        ...dispatchProps,
        ...stateProps,
        ...ownProps
    }
}

const mapDispatchToProps = (dispatch) => {
    return ({
        new: (clock) => { return dispatch(newClock(clock))},
        back: ()=>{dispatch(push('/clock/admin/reports'))},
        goTo: (id)=>{dispatch(push(`/clock/admin/${id}`))},
        init: ()=>{
            dispatch(loadClock());
            dispatch(getEmployees());
        }
    })
};


// No need to connect()!
export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(ClockNew)



// WEBPACK FOOTER //
// ./src/scenes/Clock/scenes/ClockNew/index.js